<app-upgrade-dosage-upsell *ngIf="upgradeDosageOptions.length > 0" [form]="form" qaIdPrefix="Upgrade Dosage Component">
  <p description class="my-4">
    <strong>You're currently taking {{ currentDosageData.dosage }} of {{ currentDosageData.name }}.</strong> To keep
    your momentum going and get the most benefit from treatment, clinical guidelines recommend increasing the dose to
    <strong>{{ nextDosageData.dosage }}</strong
    >. This stepwise approach helps your body continue responding effectively while keeping side effects manageable.
  </p>

  <div options [formGroup]="form">
    <label class="label">Would you like to increase your dose to {{ nextDosageData.dosage }}?</label>
    <div class="control">
      <label class="radio">
        <input
          [attr.data-qa-id]="'Upgrade Dosage Component Yes'"
          formControlName="upgradeDosage"
          [value]="upgradeDosageOptions[0].value"
          type="radio"
        />
        Yes, I'm ready to increase to {{ nextDosageData.dosage }}
      </label>
    </div>
    <div class="control">
      <label class="radio">
        <input
          [attr.data-qa-id]="'Upgrade Dosage Component No'"
          formControlName="upgradeDosage"
          value="No"
          type="radio"
        />
        No, I'd like to stay on {{ currentDosageData.dosage }} for another month.
      </label>
    </div>
  </div>

  <div hint class="hint">
    Most patients select this option, and it comes with a small ${{ nextDosageData.price }} additional charge.
  </div>
</app-upgrade-dosage-upsell>
